// extracted by mini-css-extract-plugin
export default {"easyAccessSwitch":"Lef0d4DwYwrbAOvZavsQ","easyAccessSwitchSwitch":"L15cn4EPdBgDjisYme32"};